export default function convertDayIndexingToSatSunFormat(date: Date) {
  return date.getDay();
}

export const getOffsetForEndOfMonth = (date: Date) => {
  return 6 - date.getDay();
};
